<mat-form-field class="w-100">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [value]="value"
    (selectionChange)="onSelectionChange($event.value)"
    (blur)="onTouched()"
    [disabled]="disabled"
    [required]="isRequired"
    [errorStateMatcher]="errorStateMatcher"
  >
    @for (country of countryList; track $index) {
      <mat-option [value]="country.code">
        @if (showFlag) {
          <span class="fi fi-{{ country.code.toLowerCase() }}"></span>
        }
        {{ country.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
